module.exports = __webpack_public_path__ + "img/character-intro.1c5c6d15.png";